// theme.js
export const blueTheme = {
  body: "#EDF9FE",
  text: "#001C55",
  expTxtColor: "#000a12",
  highlight: "#A6E1FA",
  dark: "#00072D",
  secondaryText: "#7F8DAA",
  imageHighlight: "#0E6BA8",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#0A2472",
  headerColor: "#0E6BA877",
  splashBg: "#001C55",
};

export const brownTheme = {
  body: "#FFFEFD",
  text: "#5D2A42",
  expTxtColor: "#000a12",
  highlight: "#FFF9EC",
  dark: "#00072D",
  secondaryText: "#8D697A",
  imageHighlight: "#E29F95",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#FB6376",
  headerColor: "#E29F9577",
  splashBg: "#5D2A42",
};

export const purpleTheme = {
  body: "#F8EFF4",
  text: "#231942",
  expTxtColor: "#000a12",
  highlight: "#E0B1CB",
  dark: "#00072D",
  secondaryText: "#655E7A",
  imageHighlight: "#BE95C4",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#5E548E",
  headerColor: "#BE95C477",
  splashBg: "#231942",
};

export const greenTheme = {
  body: "#FFFFEB",
  text: "#003F2F",
  expTxtColor: "#000a12",
  highlight: "#dddf00",
  dark: "#00072D",
  secondaryText: "#4CA58F",
  imageHighlight: "#55a630",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#007f5f",
  headerColor: "#55a63077",
  splashBg: "#003F2F",
};

export const redTheme = {
  body: "#FFF8E6",
  text: "#6a040f",
  expTxtColor: "#000a12",
  highlight: "#ffba08",
  dark: "#03071e",
  secondaryText: "#964F56",
  imageHighlight: "#dc2f02",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#9d0208",
  headerColor: "#dc2f0277",
  splashBg: "#6a040f",
};

export const blackTheme = {
  body: "#E5E5E5",
  text: "#14213d",
  expTxtColor: "#000a12",
  highlight: "#ffffff",
  dark: "#000000",
  secondaryText: "#5A6377",
  imageHighlight: "#fca311",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#8d99ae",
  headerColor: "#fca31177",
  splashBg: "#14213d",
};

export const pinkTheme = {
  body: "#FEE9F2",
  text: "#620E34",
  expTxtColor: "#000a12",
  highlight: "#FBA7CD",
  dark: "#31071A",
  secondaryText: "#ef476f",
  imageHighlight: "#ef476f",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#8d99ae",
  headerColor: "#ef476f77",
  splashBg: "#620E34",
};

export const violetTheme = {
  body: "#F4EEFC",
  text: "#430A58",
  expTxtColor: "#000a12",
  highlight: "#D6BEF4",
  dark: "#21052C",
  secondaryText: "#875599",
  imageHighlight: "#9b5de5",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#763D8B",
  headerColor: "#9b5de577",
  splashBg: "#430A58",
};

export const tealTheme = {
  body: "#E6FAF5",
  text: "#084c61",
  expTxtColor: "#000a12",
  highlight: "#9BEED8",
  dark: "#031E26",
  secondaryText: "#528190",
  imageHighlight: "#07beb8",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#56a3a6",
  headerColor: "#07beb877",
  splashBg: "#084c61",
};

export const orangeTheme = {
  body: "#FFF0EA",
  text: "#99401F",
  expTxtColor: "#000a12",
  highlight: "#FFB59A",
  dark: "#33150A",
  secondaryText: "#CC552A",
  imageHighlight: "#FF6B35",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#d7263d",
  headerColor: "#FF6B3577",
  splashBg: "#99401F",
};

export const yellowTheme = {
  body: "#FFD95D",
  text: "#5f4339",
  expTxtColor: "#000a12",
  highlight: "#ffff73",
  dark: "#8d6e63",
  secondaryText: "#5f4339",
  imageHighlight: "#ffea3d",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#4e342e",
  headerColor: "#FFEA3D",
  splashBg: "#5f4339",
};

export const materialDarkTheme = {
  body: "#263238",
  text: "#aeaeae",
  expTxtColor: "#000a12",
  highlight: "#4f5b62",
  dark: "#000a12",
  secondaryText: "#aeaeae",
  imageHighlight: "#607d8b",
  compImgHighlight: "#E6E6E6",
  jacketColor: "#8eacbb",
  headerColor: "#34515e",
  splashBg: "#4f5b62",
};

export const materialLightTheme = {
  body: "#ffffff",
  text: "#4c2b91",
  expTxtColor: "#000000",
  highlight: "#E9E3F5",
  dark: "#1d0c41",
  secondaryText: "#7d56c2",
  imageHighlight: "#2b1958",
  compImgHighlight: "#E1E2E1",
  jacketColor: "#E1E2E1",
  headerColor: "#E1E2E1",
  splashBg: "#7d56c2",
};

export const materialTealTheme = {
  body: "#ffffff",
  text: "#05505E",
  expTxtColor: "#000000",
  highlight: "#a1dded",
  dark: "#07292c",
  secondaryText: "#05505E",
  imageHighlight: "#0a343c",
  compImgHighlight: "#E1E2E1",
  jacketColor: "#E1E2E1",
  headerColor: "#E1E2E1",
  splashBg: "#05505E",
};

// ============================================================
// 1. الثيم الليلي الملكي – Midnight Sovereign
//    فخامة البيانات: أزرق داكن مع ذهب عتيق
// ============================================================
export const midnightSovereignTheme = {
  body: "#0B0F1A",
  text: "#E8DCC8",
  expTxtColor: "#C9B28A",
  highlight: "#D4AF37",
  dark: "#05080F",
  secondaryText: "#8A7A5A",
  imageHighlight: "#D4AF37",
  compImgHighlight: "#1A1F2E",
  jacketColor: "#C9A84C",
  headerColor: "#D4AF3733",
  splashBg: "#0B0F1A",
};

// ============================================================
// 2. الثيم البلوري البلاتيني – Crystal Platinum
//    نقاء البيانات: فضي بلاتيني مع ياقوت أزرق
// ============================================================
export const crystalPlatinumTheme = {
  body: "#F9F7F2",
  text: "#141824",
  expTxtColor: "#2A2F45",
  highlight: "#3D5A80",
  dark: "#0A0D18",
  secondaryText: "#5A6A8A",
  imageHighlight: "#C0C8D8",
  compImgHighlight: "#E8EAF0",
  jacketColor: "#1A2A4A",
  headerColor: "#3D5A8033",
  splashBg: "#141824",
};

// ============================================================
// 3. الثيم البنفسجي الأسود – Violet Noir
//    ذكاء اصطناعي فاخر: بنفسجي غامق مع وردة ذهبية
// ============================================================
export const violetNoirTheme = {
  body: "#100B1A",
  text: "#F0E6F5",
  expTxtColor: "#C4A8D0",
  highlight: "#E8A87C",
  dark: "#08050D",
  secondaryText: "#8A7A9A",
  imageHighlight: "#C77DFF",
  compImgHighlight: "#1A1428",
  jacketColor: "#E8A87C",
  headerColor: "#E8A87C33",
  splashBg: "#100B1A",
};

// ============================================================
// 4. ثيم مصفوفة الزمرد – Emerald Matrix
//    تقنية متقدمة: أسود كربوني مع أخضر زمردي مشع
// ============================================================
export const emeraldMatrixTheme = {
  body: "#0D1117",
  text: "#C9D1D9",
  expTxtColor: "#8B949E",
  highlight: "#2EA043",
  dark: "#010409",
  secondaryText: "#58A6FF",
  imageHighlight: "#3FB950",
  compImgHighlight: "#161B22",
  jacketColor: "#238636",
  headerColor: "#2EA04333",
  splashBg: "#0D1117",
};

// ============================================================
// 5. ثيم الحمم البركانية السوداء – Obsidian Lava
//    قوة البيانات: أسود أوبسيديان مع برتقالي ناري
// ============================================================
export const obsidianLavaTheme = {
  body: "#1A1A1B",
  text: "#D7DADC",
  expTxtColor: "#818384",
  highlight: "#FF4500",
  dark: "#030303",
  secondaryText: "#D7DADC",
  imageHighlight: "#FF585B",
  compImgHighlight: "#272729",
  jacketColor: "#FF4500",
  headerColor: "#FF450033",
  splashBg: "#1A1A1B",
};

// ============================================================
// 6. ثيم الرمال الملكية – Royal Sandstone
//    أناقة كلاسيكية: بيج رملي مع أزرق ملكي
// ============================================================
export const royalSandstoneTheme = {
  body: "#FDF5E6",
  text: "#2F4F4F",
  expTxtColor: "#483D8B",
  highlight: "#4169E1",
  dark: "#191970",
  secondaryText: "#708090",
  imageHighlight: "#6495ED",
  compImgHighlight: "#FFF8DC",
  jacketColor: "#000080",
  headerColor: "#4169E133",
  splashBg: "#FDF5E6",
};

// ============================================================
// 7. ثيم الذكاء السيبراني – Cyber Intelligence
//    مستقبلي: رمادي حديدي مع أزرق سياني كهربائي
// ============================================================
export const cyberIntelligenceTheme = {
  body: "#202124",
  text: "#E8EAED",
  expTxtColor: "#9AA0A6",
  highlight: "#8AB4F8",
  dark: "#171717",
  secondaryText: "#BDC1C6",
  imageHighlight: "#4285F4",
  compImgHighlight: "#303134",
  jacketColor: "#1A73E8",
  headerColor: "#8AB4F833",
  splashBg: "#202124",
};

// ============================================================
// 8. ثيم الغسق الأرجواني – Deep Dusk Purple
//    هدوء وعمق: أرجواني عميق مع لمسات من الفضة
// ============================================================
export const deepDuskPurpleTheme = {
  body: "#2D1B33",
  text: "#F3E5F5",
  expTxtColor: "#CE93D8",
  highlight: "#BA68C8",
  dark: "#1A0F1E",
  secondaryText: "#E1BEE7",
  imageHighlight: "#AB47BC",
  compImgHighlight: "#3D2645",
  jacketColor: "#8E24AA",
  headerColor: "#BA68C833",
  splashBg: "#2D1B33",
};

// ============================================================
// 9. ثيم الجرافيت الذهبي – Golden Graphite
//    فخامة عصرية: رمادي جرافيت مع ذهب مصقول
// ============================================================
export const goldenGraphiteTheme = {
  body: "#3C3C3C",
  text: "#FFFFFF",
  expTxtColor: "#D4AF37",
  highlight: "#FFD700",
  dark: "#1A1A1A",
  secondaryText: "#E5E5E5",
  imageHighlight: "#DAA520",
  compImgHighlight: "#4A4A4A",
  jacketColor: "#B8860B",
  headerColor: "#FFD70033",
  splashBg: "#3C3C3C",
};

// ============================================================
// 10. ثيم المحيط المظلم – Deep Ocean Mystery
//    غموض واحترافية: أزرق بحري عميق مع فيروزي مشع
// ============================================================
export const deepOceanMysteryTheme = {
  body: "#001219",
  text: "#E9D8A6",
  expTxtColor: "#94D2BD",
  highlight: "#EE9B00",
  dark: "#000000",
  secondaryText: "#005F73",
  imageHighlight: "#0A9396",
  compImgHighlight: "#001E29",
  jacketColor: "#CA6702",
  headerColor: "#EE9B0033",
  splashBg: "#001219",
};

export const chosenTheme = tealTheme;
